import Button from 'components/common/Button';
import { AvatarOnRubberRing } from 'components/referrals/2026/AvatarOnRubberRing';
import Link from 'next/link';
import { useMemo } from 'react';
import { getRandomMascotAvatar } from 'utils/dashboard/avatar';
import BeachTopRight from '../../../svg/refer-a-friend/BeachTopRight.svg';
import styles from './MenuAnnouncement.module.css';

const WinWithFriendsAnnouncement = () => {
  const randomFriendAvatar = useMemo(() => getRandomMascotAvatar(), []);

  return (
    <div className={styles.winWithFriends}>
      <Link href="/referrals">
        <div className={styles.content}>
          <div className={styles.referrerImage}>
            <AvatarOnRubberRing avatarUrl={randomFriendAvatar} />
          </div>
          <div className={styles.textWrapper}>
            <div className="daymadeTypographyMMedium">
              <span className="daymadeTypographyMBold">Invite</span> your friend{' '}
              <br />
              and <span className="daymadeTypographyMBold">win</span> together
            </div>
            <Button buttonStyle="Tertiary" buttonSize="Small">
              Discover more
            </Button>
          </div>
        </div>
        <BeachTopRight className={styles.beachTopRight} />
      </Link>
    </div>
  );
};

export default WinWithFriendsAnnouncement;
